export default __webpack_public_path__ + "static/media/Crafty_Pie_pfp.d618dab9.png";